import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import classNames from 'classnames';
import Tooltip from '../Tooltip';
import { getMultiLang, debounce, isBooleanType, isFunction, getGlobalStorage, setGlobalStorage, getAppReqParam, PubSub } from '@platform/api';
const COMPLETE = 'areaChangeComplete';

require('./dragHeight.less');

export default class DragHeightCom extends Component {
    constructor(props) {
        super(props);
        this.mouseDown = false;
        let newExpandFlag = isBooleanType(this.props.defaultExpandFlag) ? this.props.defaultExpandFlag : false;
        // false 不显示中间线  true 显示中间线
        let newShowDragLine = isBooleanType(this.props.showDragLine) ? this.props.showDragLine : true;
        let newAdaptionHeight = isBooleanType(this.props.adaptionHeight) ? this.props.adaptionHeight : false;
        let defTopHeight = this.getDefaultHeight(this.props.defTopHeight);
        this.state = {
            expandFlag: newExpandFlag,
            tabActiveKey: this.props.tabActiveKey,
            showDragLine: newShowDragLine,
            json: {
                index_000: "展开",
                index_001: "收起",
            },
            LangData: null,
            adaptionHeight: newAdaptionHeight, // 自适应高度
            defTopHeight: defTopHeight,
        };
        this.expandSideBox = this.expandSideBox.bind(this);
        this.getRelationCode();
        this.defaultExpandFlag = this.props.defaultExpandFlag;
    }

    bindFlexDOM = dom => {
        this.divDom = dom;
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        let { expandFlag, tabActiveKey, showDragLine, adaptionHeight, defTopHeight } = nextProps;
        defTopHeight = this.getDefaultHeight(defTopHeight);
        let { expandFlag: oldExpandFlag, tabActiveKey: oldTabActiveKey, showDragLine: oldShowDragLine, adaptionHeight: oldAdaptionHeight, defTopHeight: oldDefTopHeight } = this.state;
        if (isBooleanType(expandFlag) && expandFlag !== oldExpandFlag) {
            this.setState({ expandFlag: expandFlag });
        }
        if (defTopHeight !== oldDefTopHeight && !this.setHeightOrExpandFlag && !(defTopHeight === 0 || defTopHeight === '0px')) {
            this.setState({ defTopHeight: defTopHeight });
        }
        if (tabActiveKey !== oldTabActiveKey) {
            this.setState({ tabActiveKey: tabActiveKey });
        }
        if (isBooleanType(showDragLine) && showDragLine !== oldShowDragLine) {
            this.setState({ showDragLine: showDragLine });
        }
        if (isBooleanType(adaptionHeight) && adaptionHeight !== oldAdaptionHeight) {
            this.setState({ adaptionHeight: adaptionHeight }, () => {
                // 高度设置为自适应或取消自适应 不再去读取缓存
                this.setHeightOrExpandFlag = true;
                this.clientHeight = this.divDom?.clientHeight;
            });
        }
        // 如果传进来的 defTopHeight 是0 或者0px 就不去读缓存了，设置新的 defTopHeight 和 expandFlag
        if (defTopHeight === 0 || defTopHeight === '0px') {
            this.setState({
                expandFlag: false,
                defTopHeight: '0px',
                // 读取缓存数据，自适应高度参数不再生效
                adaptionHeight: false,
            });
        }
    }
    UNSAFE_componentWillMount() {
        let callback = (json, bool, LangData) => {
            this.setState({ json, LangData });
        };
        getMultiLang({ moduleId: 'contains_dragWidth', callback });
        // 读本地缓存
        this.getDragHeightStorage();

    }
    componentDidMount() {
        if (this.divDom) {
            this.clientHeight = this.divDom.clientHeight;
        }

        window.addEventListener('unload', this.beforeunloadListener);
        // window.addEventListener('resize', this.handleExpandBtn);
        this.onMouseDown.call(this);
        // this.handleExpandBtn();
        // this.searchAreaChange = PubSub.subscribe(COMPLETE, (msg, data) => {
        //     console.log(msg, data, 'searchChoosePlan只能通过全局订阅发布做了');
        //     if (data) {
        //         this.handleExpandBtn();
        //     }
        // });
    }
    componentWillUnmount() {
        this.beforeunloadListener();
        window.removeEventListener('unload', this.beforeunloadListener);
        // window.removeEventListener('resize', this.handleExpandBtn);
        document.removeEventListener('mousemove', this.handleMouseMove);
        document.removeEventListener('mouseup', this.handleMouseUp);
        if (this.spanDom) {
            this.spanDom.removeEventListener('mousedown', this.handleMouseDown);
        }
    }

    componentDidUpdate() {
        this.onMouseDown.call(this);
        this.getDragHeightStorage();
        // this.handleExpandBtn();
    }

    // 处理按钮的显示隐藏和位置
    handleExpandBtn = () => {
        let { showDragLine = true, expandFlag } = this.state;
        let { showExpandBtn = true, topDom, bottomDom, aside = 'top' } = this.props;
        if (showDragLine && showExpandBtn) {
            setTimeout(() => {
                let position = this.box?.getBoundingClientRect();
                let windowHeight = window.innerHeight;
                if (position && this.fakeBtn && this.realBtn) {
                    let style = window.getComputedStyle(this.box);
                    let paddingTop = style && style.paddingTop;
                    let paddingBottom = style && style.paddingBottom;
                    let asideTop = (Math.round(position.top) + Number(paddingTop.replace('px', ''))) + 'px';
                    let asideBottom = (Math.round(position.bottom) - Number(paddingBottom.replace('px', ''))) + 'px';
                    this.fakeBtn.style.top = aside === 'top' ? asideTop : asideBottom;
                    this.fakeBtn.style.left = (Math.round(position.left + position.right) / 2) + 'px';
                    this.fakeBtn.style.position = 'fixed';
                    if (asideTop > windowHeight) {
                        return;
                    }
                    if (!expandFlag) {
                        this.fakeBtn.style.display = 'flex';
                        this.realBtn.style.display = 'none';
                    } else {
                        this.realBtn.style.display = 'flex';
                        this.fakeBtn.style.display = 'none';
                    }
                }
            }, 200);
        }
        if ((topDom === null || bottomDom === null) && expandFlag) {
            setTimeout(() => {
                let position = this.box?.getBoundingClientRect();
                let windowHeight = window.innerHeight;
                if (position && this.fakeBtn && this.realBtn) {
                    let style = window.getComputedStyle(this.box);
                    let paddingTop = style && style.paddingTop;
                    let paddingBottom = style && style.paddingBottom;
                    let asideTop = (Math.round(position.bottom) + Number(paddingTop.replace('px', '')) - 1) + 'px';
                    let asideBottom = (Math.round(position.top) - Number(paddingBottom.replace('px', ''))) + 'px';
                    this.fakeBtn.style.top = aside === 'top' ? asideTop : asideBottom;
                    this.fakeBtn.style.left = (Math.round(position.right) / 2) + 'px';
                    this.fakeBtn.style.position = 'fixed';
                    if (asideTop > windowHeight) {
                        return;
                    }
                    this.realBtn.style.display = 'none';
                    this.fakeBtn.style.display = 'flex';
                }
            }, 200);
        }
    }

    getDefaultHeight = defTopHeight => {
        // addChartLink 图表联动筛选 默认false 领域传入true使用UE提供的另一套高度方案
        let { addChartLink = false } = this.props;
        // NCC-286619 关键信息区高度根据不同分辨率尺寸适配
        let clientWidth = document.body.clientWidth;
        let defaultHeight = addChartLink ? '150px' : '120px';
        if (clientWidth >= 1921) {
            defaultHeight = addChartLink ? '230px' : '200px';
        } else if (clientWidth >= 1440) {
            defaultHeight = addChartLink ? '190px' : '160px';
        }
        if (defTopHeight === undefined || defTopHeight === null || defTopHeight === '') {
            return defaultHeight;
        }
        return defTopHeight;
    }

    beforeunloadListener = () => {
        let { appCode = this.appCode, pageCode = this.pageCode, moduleId, useCache = true } = this.props;
        // useCache 启用缓存，默认true
        if (!useCache) {return;}
        // 组件销毁前缓存当前 moduleId 的展开收起状态，以及当前设置的高度
        let { expandFlag, defTopHeight } = this.state;
        // let oldExpandFlag = isBooleanType(this.props.expandFlag) ? this.props.expandFlag : true;
        let { defTopHeight: oldDefTopHeight } = this.props;
        oldDefTopHeight = this.getDefaultHeight(oldDefTopHeight);
        // if (expandFlag === oldExpandFlag && defTopHeight === oldDefTopHeight) {
        //     // 如果没有任何操作，不缓存
        //     return;
        // }
        let dragHeightStorage = {
            expandFlag,
            defTopHeight,
        };

        let userDataJSON = getGlobalStorage('localStorage', "STOREFORINFODATA");
        let userData = userDataJSON && JSON.parse(userDataJSON);
        let userid = userData && userData.userId;
        let localStorage = 'customer_drag_height';
        let drag_height_storage = JSON.parse(getGlobalStorage('localStorage', localStorage)) || {};
        drag_height_storage[appCode + '_' + pageCode + '_' + moduleId + '_' + userid] = dragHeightStorage;
        try {
            setGlobalStorage('localStorage', localStorage, JSON.stringify(drag_height_storage));
        } catch (e) {
            console.log('浏览器localStorage容量不足');
        }
    }

    getDragHeightStorage() {
        let { appCode = this.appCode, pageCode = this.pageCode, moduleId, useCache = true, defTopHeight, defaultExpandFlag } = this.props;
        // useCache 启用缓存，默认true
        if (!useCache) {return;}
        let userDataJSON = getGlobalStorage('localStorage', "STOREFORINFODATA");
        let userData = userDataJSON && JSON.parse(userDataJSON);
        let userid = userData && userData.userId;
        let localStorage = 'customer_drag_height';
        let drag_height_storage = JSON.parse(getGlobalStorage('localStorage', localStorage)) || {};
        let dragHeightStorage = drag_height_storage[appCode + '_' + pageCode + '_' + moduleId + '_' + userid];
        if (dragHeightStorage && !this.setHeightOrExpandFlag && !(defTopHeight === 0 || defTopHeight === '0px')) {
            let { expandFlag: storageExpandFlag, defTopHeight: storageDefTopHeight } = dragHeightStorage;
            let { expandFlag, defTopHeight } = this.state;
            if (!storageDefTopHeight) {
                storageDefTopHeight = this.getDefaultHeight();
            }
            if (storageExpandFlag !== expandFlag || storageDefTopHeight !== defTopHeight) {
                this.setState({
                    expandFlag: storageExpandFlag,
                    defTopHeight: storageDefTopHeight,
                    // 读取缓存数据，自适应高度参数不再生效
                    adaptionHeight: false,
                });
            }
        } else if (!dragHeightStorage && defaultExpandFlag !== this.defaultExpandFlag) {
            this.defaultExpandFlag = defaultExpandFlag;
            this.setState({ expandFlag: defaultExpandFlag });
        }
    }

    handleMouseMove = event => {
        //e.stopPropagation();
        if (this.mouseDown && this.divDom) {
            let { aside = "top", onDragMove } = this.props;
            this.box.style.userSelect = "none";
            // fix bug  IE  e.x !== e.clientx  ie  
            let height = 0;
            let minHeight = this.props.topMinHeight && parseInt(this.props.topMinHeight);
            // 方向不一样，需要根据方向做加减法
            if (aside === "top") {
                height = this.clientHeight + (event.clientY - this.beginY);
            } else if (aside === "bottom") {
                height = this.clientHeight + (this.beginY - event.clientY);
            }
            if (height >= this.box.clientHeight - 20) {
                this.divDom.style.height = (this.box.clientHeight - 20) + 'px';
            } else if (height <= minHeight) {
                this.divDom.style.height = minHeight + 'px';
            } else {
                this.divDom.style.height = height + 'px';
            }
            if (isFunction(onDragMove)) {
                debounce(onDragMove.bind(this, this.divDom.style.height, event), 20)();
            }

        }
    };

    handleMouseUp = event => {
        if (this.mouseDown) {
            // 拖拽改变高度，setHeightOrExpandFlag 设置为true
            this.setHeightOrExpandFlag = true;

            this.mouseDown = false;
            this.box.style.userSelect = "auto";
            if (this.divDom) {
                this.clientHeight = this.divDom.clientHeight;
            }
            this.maskRightDom && (this.maskRightDom.style.display = 'none');
            this.maskLeftDom && (this.maskLeftDom.style.display = 'none');

            isFunction(this.props.onDragStop) && this.props.onDragStop(this.divDom?.style.height, event);

            this.setState({ adaptionHeight: false, defTopHeight: this.clientHeight }, () => {
                // 把伸缩的动画样式加回来
                this.divDom && this.divDom.classList.add('clickHeightCom_transition');
            });
        }
    };

    handleMouseDown = event => {
        // draggable 默认开启拖拽
        let { draggable = true } = this.props;
        if (!draggable) {return;}
        if (!this.state.expandFlag) {return;}
        if (this.divDom) {
            this.clientHeight = this.divDom.clientHeight;
        }
        this.beginY = event.clientY;
        this.mouseDown = true;
        isFunction(this.props.onMouseDown) && this.props.onMouseDown(event);
        // 加个遮罩 应对  iframe的情况
        this.maskRightDom && (this.maskRightDom.style.display = 'block');
        this.maskLeftDom && (this.maskLeftDom.style.display = 'block');
        // 把伸缩的动画样式删除
        this.divDom && this.divDom.classList.remove('clickHeightCom_transition');
    };

    onMouseDown() {
        document.addEventListener('mousemove', this.handleMouseMove);
        document.addEventListener('mouseup', this.handleMouseUp);
        if (this.spanDom) {
            this.spanDom.addEventListener('mousedown', this.handleMouseDown);
        }
    }

    expandSideBox() {
        // 展开收起状态发生变化，setHeightOrExpandFlag 设置为true
        this.setHeightOrExpandFlag = true;

        let { expandFlag } = this.state;
        let newExpandFlag = !expandFlag;
        this.setState({ expandFlag: newExpandFlag }, () => {
            // if (!newExpandFlag) {
            //     setTimeout(() => {
            //         this.fakeBtn.style.display = 'flex';
            //         this.realBtn.style.display = 'none';
            //     }, 300);
            // } else {
            //     this.realBtn.style.display = 'flex';
            //     this.fakeBtn.style.display = 'none';
            // }
            // NCC-302720 动画结束后更新下组件，通知到表格计算滚动条的位置
            // asyncExpand 默认 true 
            let { asyncExpand = true } = this.props;
            if(asyncExpand){
                setTimeout(() => {
                    isFunction(this.props.onExpand) && this.props.onExpand(newExpandFlag, "vertical");
                }, 300);
            }else{
                isFunction(this.props.onExpand) && this.props.onExpand(newExpandFlag, "vertical");
            }
        });
    }

    renderExpandBtn() {
        let { aside = 'top' } = this.props;
        let { expandFlag, json = {} } = this.state;
        // let position = this.box?.getBoundingClientRect();
        // let style = { display: 'none' };
        // if (position) {
        //     style.top = aside === 'top' ? (Math.round(position.top)) + 'px' : (Math.round(position.bottom)) + 'px';
        //     style.left = (Math.round(position.right) / 2) + 'px';
        //     style.position = 'fixed';
        let btnDom = <Tooltip
            placement="top"
            overlay={expandFlag ? json.index_001 : json.index_000}
            delayHide={1}
            delayShow={500}
            trigger={'hover'}
        >
            <div
                ref={dom => this.fakeBtn = dom}
                className={
                    classNames(
                        'drag-width-icon-fake',
                        {
                            'drag-width-icon-top-expend': aside === "top" && expandFlag,
                            'drag-width-icon-bottom-expend': aside === "bottom" && expandFlag,
                            'drag-width-icon-bottom': aside === "bottom" && !expandFlag,
                            'drag-width-icon-top': aside === "top" && !expandFlag,
                        },
                    )}
                onClick={this.expandSideBox}
            // style={style}
            >
                <i className='iconfont icon-shangxiafenlan-zhankai'></i>
            </div>
        </Tooltip>;
        return ReactDOM.createPortal(btnDom, document.body);
        // }

    }

    getRelationCode = () => {
        let appReqParam = getAppReqParam();
        this.pageCode = appReqParam.pagecode;
        this.appCode = appReqParam.appcode;
    }

    render() {
        let {
            topMinHeight = '50px',
            aside = "top", // "bottom" 侧边栏在右侧 "top" 侧边栏在左侧
            topDom,
            bottomDom,
            showExpandBtn = true, // false 不显示展开收起按钮  true 显示展开收起按钮 
            // showDragLine = true, 
            className = '',
            draggable = true,
            bottomClassName,
            showVerArea = true,
            visible = true,
            usePosition = true, // 上下分栏使用绝对定位优化动画效果
        } = this.props;
        // 解决 领域传 defLeftWid="150px" leftMinWid = "300px" 的问题
        // let newDefLeftWid = parseInt(defLeftWid) > parseInt(leftMinWid) ? defLeftWid : leftMinWid;
        let { expandFlag, json, showDragLine, adaptionHeight, defTopHeight } = this.state;
        let bottomStyle = bottomClassName ? { background: 'transparent' } : {};
        let isChrome70 = navigator.userAgent.indexOf('Chrome/70.') > -1;
        // 表单里的上下分栏不需要添加id，避免影响楼层组件定位
        let isFormDragHeightCom = className === 'dragHeightComFormCardContainer';
        if (visible === false) {
            return null;
        }
        return (
            <div
                className={`dragHeightCom ${className} ${expandFlag ? 'dragHeightComExpand' : ''}`}
                ref={box => {
                    this.box = box;
                }}
                style={{ ...bottomStyle }}
            >
                {showVerArea && <div
                    className={
                        classNames(
                            'dragHeightCom_top',
                            {
                                dragHeightComFlex_top: aside === "bottom",
                                clickHeightCom_transition: aside === "top",
                                clickHeightCom_min: (aside === "top" && !expandFlag),
                                dragHeightComFlex_top_expand: (aside === "bottom" && expandFlag),
                            },
                        )
                    }
                    style={aside === "top" ? (adaptionHeight ? { height: 'auto', ...bottomStyle } : { height: defTopHeight, minHeight: expandFlag ? topMinHeight : 0, ...bottomStyle }) : { ...bottomStyle }}
                    ref={aside === "top" ? this.bindFlexDOM : null}
                    id='dragHeightCom_top'
                >
                    <div className="dragHeightCom_mask" ref={mask => { this.maskLeftDom = mask; }} />
                    {topDom ? typeof topDom === 'function' ? topDom({ expandFlag }) : React.cloneElement(topDom, { expandFlag }) : null}
                </div>}
                {showDragLine &&
                    <div
                        className={
                            classNames(
                                'dragHeightCom_line',
                                draggable ? '' : 'dragHeightCom_lines_resize',
                                (aside === "top" && !expandFlag) ? 'dragHeightCom_line_expand_top' : '',
                                (aside === "bottom" && !expandFlag) ? 'dragHeightCom_line_expand_bottom' : '',
                            )
                        }
                    >
                        <div
                            className={
                                classNames(
                                    'dragHeightCom_lines_wrapper',
                                    expandFlag ? '' : 'dragHeightCom_lines_resize',
                                    draggable ? '' : 'dragHeightCom_lines_resize',
                                )
                            }
                            ref={span => {
                                this.spanDom = span;
                            }}
                        >
                            <div

                                className={
                                    classNames(
                                        'dragHeightCom_lines',
                                        aside === "bottom" ? 'dragHeightComBottom_lines' : '',
                                        draggable ? '' : 'dragHeightCom_lines_resize',
                                    )
                                }
                            />
                        </div>
                        {showExpandBtn && <Tooltip
                            placement="top"
                            overlay={expandFlag ? json.index_001 : json.index_000}
                            delayHide={1}
                            delayShow={500}
                            trigger={'hover'}
                        >
                            <div
                                ref={dom => this.realBtn = dom}
                                className={
                                    classNames(
                                        'drag-width-icon-real',
                                        {
                                            'drag-width-icon-top-expend': aside === "top" && expandFlag,
                                            'drag-width-icon-bottom-expend': aside === "bottom" && expandFlag,
                                            'drag-width-icon-bottom': aside === "bottom" && !expandFlag,
                                            'drag-width-icon-top': aside === "top" && !expandFlag,
                                        },
                                    )}
                                onClick={this.expandSideBox}
                                id='drag-width-icon-real'
                            >
                                <i className='iconfont icon-shangxiafenlan-zhankai'></i>
                            </div>
                        </Tooltip>}
                        {/* {showExpandBtn && this.renderExpandBtn()} */}
                    </div>
                }
                <div
                    className={
                        classNames(
                            'dragHeightCom_bottom',
                            `${bottomClassName}`,
                            {
                                dragHeightComFlex_bottom: aside === "bottom",
                                clickHeightCom_transition: aside === "bottom",
                                clickHeightCom_bottom: (aside === "bottom" && !expandFlag),
                            },
                        )
                    }
                    id={isFormDragHeightCom ? "" : "dragHeightCom_bottom"}
                    style={aside === "bottom" ? (adaptionHeight ? { height: 'auto', ...bottomStyle } : { height: defTopHeight, minHeight: expandFlag ? topMinHeight : 0, ...bottomStyle }) : { ...bottomStyle }}
                    ref={aside === "bottom" ? this.bindFlexDOM : null}
                >
                    <div className="dragHeightCom_mask" ref={mask => { this.maskRightDom = mask; }} />
                    {/* {bottomDom ? typeof bottomDom === 'function' ? bottomDom({ expandFlag }) : React.cloneElement(bottomDom, { expandFlag }) : null} */}
                    {bottomDom ?
                        typeof bottomDom === 'function' ? bottomDom({ expandFlag })
                            : isChrome70 || !usePosition ?
                                (bottomDom ? React.cloneElement(bottomDom, { expandFlag }) : null)
                                : <div className='dragHeightCom_drawer' id='dragHeightCom_drawer' ref={dom => { this.drawerDom = dom; }}>
                                    {bottomDom ? React.cloneElement(bottomDom, { expandFlag }) : null}
                                </div>
                        : null}
                </div>
            </div >
        );
    }
}
